import { render, staticRenderFns } from "./CSPTable.vue?vue&type=template&id=1fe498a1&scoped=true"
import script from "./CSPTable.vue?vue&type=script&lang=js"
export * from "./CSPTable.vue?vue&type=script&lang=js"
import style0 from "./CSPTable.vue?vue&type=style&index=0&id=1fe498a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe498a1",
  null
  
)

export default component.exports